import { Injectable } from '@angular/core';
import { BaseEnumService } from '@fleet-beat/core';

export const enum EditorFieldType {
  HIDDEN = 'hidden',
  STRING = 'string',
  TEXT_AREA = 'text-area',
  TEMPLATE = 'templated-field',
  NUMBER = 'number',
  CURRENCY = 'currency',
  PERCENT = 'percent',
  EMAIL = 'email',
  EMAIL_LIST = 'email-list',
  PHONE = 'phone',
  CHECKBOX = 'checkbox',
  CHECKBOX_LIST = 'checkbox-list',
  FILE = 'file',
  FILE_LIST = 'file_list',
  SELECT_AUTOCOMPLETE = 'select-autocomplete',
  DATA_AUTOCOMPLETE = 'data-autocomplete',
  DATE = 'date',
  DATE_RANGE = 'date-range',
  RADIO = 'radio',
  PASSWORD = 'password',
  RATING = 'rating',
  TIME = 'time',
  TIME2 = 'time2',
  ON_OFF = 'on-off',
  COLOR = 'color',
  SELECT_TREE = 'select-tree',
  SELECT_DATA = 'select-data',
  IOS_TOGGLE = 'ios-toggle',
  DOCUMENT_UPLOAD = 'document-upload',
  MASK = 'mask',
  NUMBER_RANGE = 'number_range',
  IMAGE_SLIDER = 'image_slider',
}

@Injectable({
  providedIn: 'root',
})
export class EditorFieldTypeEnumService extends BaseEnumService<EditorFieldType> {
  protected readonly data: Record<string, EditorFieldType> = {
    HIDDEN: EditorFieldType.HIDDEN,
    STRING: EditorFieldType.STRING,
    NUMBER: EditorFieldType.NUMBER,
    EMAIL: EditorFieldType.EMAIL,
    PHONE: EditorFieldType.PHONE,
    CHECKBOX: EditorFieldType.CHECKBOX,
    CHECKBOX_LIST: EditorFieldType.CHECKBOX_LIST,
    FILE: EditorFieldType.FILE,
    FILE_LIST: EditorFieldType.FILE_LIST,
    DATE: EditorFieldType.DATE,
    DATE_RANGE: EditorFieldType.DATE_RANGE,
    RADIO: EditorFieldType.RADIO,
    PASSWORD: EditorFieldType.PASSWORD,
    RATING: EditorFieldType.RATING,
    TEMPLATE: EditorFieldType.TEMPLATE,
    TIME: EditorFieldType.TIME,
    TIME2: EditorFieldType.TIME2,
    SELECT_AUTOCOMPLETE: EditorFieldType.SELECT_AUTOCOMPLETE,
    DATA_AUTOCOMPLETE: EditorFieldType.DATA_AUTOCOMPLETE,
    CURRENCY: EditorFieldType.CURRENCY,
    PERCENT: EditorFieldType.PERCENT,
    TEXT_AREA: EditorFieldType.TEXT_AREA,
    EMAIL_LIST: EditorFieldType.EMAIL_LIST,
    ON_OFF: EditorFieldType.ON_OFF,
    COLOR: EditorFieldType.COLOR,
    SELECT_TREE: EditorFieldType.SELECT_TREE,
    SELECT_DATA: EditorFieldType.SELECT_DATA,
    IOS_TOGGLE: EditorFieldType.IOS_TOGGLE,
    DOCUMENT_UPLOAD: EditorFieldType.DOCUMENT_UPLOAD,
    MASK: EditorFieldType.MASK,
    NUMBER_RANGE: EditorFieldType.NUMBER_RANGE,
    IMAGE_SLIDER: EditorFieldType.IMAGE_SLIDER,
  };

  private readonly enumMap: Record<string, boolean> = Object.keys(this.data).reduce(
    (result: Record<string, boolean>, key: string) => {
      result[this.data[key]] = true;
      return result;
    },
    {},
  );

  includes(value: string): boolean {
    return Boolean(this.enumMap[value]);
  }
}
